/* eslint-disable */
import axios from 'axios'

// Módulo para obtener y modificar datos de usuario en trekksoft 
const baseUrl = process.env.VUE_APP_BASE_API + '/zt/'


const actions = {
    async syncZeroToursBookings({
        commit, dispatch
    }, data) {
        await axios
            .get(baseUrl + 'sync_bookings/?day_init=' + data.day_init + '&day_end=' + data.day_end)
            .then( resonse => {
                
            })
    }
}

export default {
    namespaced: true,
    actions
}